// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';

const styles = css`
  .border {
    border-top: 1px solid ${(props) => props.theme.colors.BORDER.BLUE};
  }
  .remember-me-text {
    ${(props) =>
      props.variation === 'checkout'
        ? `font-weight:bold;font-size:${props.theme.typography.fontSizes.fs14};`
        : ''}
  }
  .save-my-plcc {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  .richTextColor a {
    color: ${(props) => props.theme.colorPalette.red[500]};
  }
  .remember-me-sub-text {
    ${(props) =>
      props.variation === 'checkout'
        ? `font-size:${props.theme.typography.fontSizes.fs12};`
        : 'display: block;'}
  }
  .rightAlignedContent {
    width: 50px;
    right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    font-size: 12px;
    a {
      font-size: 12px;
    }
  }
  .resend-email-link {
    font-size: ${(props) => props.theme.typography.fontSizes.fs13};
    font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
  }
  .newLoginScreenPassField {
    margin-bottom: 0px;
    .rightAlignedContent {
      right: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    }
  }
  .forgot-pass {
    font-size: 12px;
    font-weight: 700;
    color: #595959;
  }
  .remember-me-new .CheckBox__input,
  .remember-me-new .CheckBox__input:before {
    border-radius: 4px;
    height: 22px;
    width: 22px;
  }
  .remember-me-new .CheckBox__input:checked:after {
    top: 4px;
    left: 9px;
  }
  .plcc-border-style {
    width: 90%;
    border: solid 4px ${(props) => props.theme.colors.PROMO.PINK};
    height: 48px;
    box-shadow: 4px 4px ${(props) => props.theme.colors.DEFAULT_ACCENT_GYM},
      8px 8px ${(props) => props.theme.colors.PLCC_BACKGROUND};
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    border-radius: 0px;
  }
  .plcc-border-style:hover {
    border: solid 4px ${(props) => props.theme.colors.PROMO.PINK};
  }
  .plcc-footer-cta-section {
    position: sticky;
    background-color: white;
    padding: 1px;
    bottom: 0px;
    width: 116%;
    margin-left: -35px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.12);
    margin-top: 46%;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      bottom: 34px;
      margin-left: -16px;
      margin-top: 48%;
      width: 108%;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 120%;
    }
  }
`;
export const customSpinnerStyle = css`
  .spinner-overlay {
    position: absolute;
  }
`;
export const RememberForgotBlock = styled.div`
  display: flex;
  justify-content: space-between;
`;
export default styles;
